import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useEntityTotals } from '@printdeal/checkout-frontend';
import { Money } from '../../../../Money';
import { SanitizedOrder } from '../../../../../types/order/Order';

interface Props {
  order: SanitizedOrder;
}

const OrderDiscountSummary = ({
  order,
}: Props) => {
  // @ts-expect-error type mismatch
  const { entityTotal } = useEntityTotals({ entity: order });

  if (entityTotal?.discounts === undefined) {
    return null;
  }

  return (
    <>
      {entityTotal.discounts.reseller && (
        <div className="pd-flex pd-gap-4" key="promotionReseller">
          <div className="pd-grow pd-font-bold">
            <FormattedMessage id="discountPlatformDiscount.reseller" defaultMessage="Reseller Discount" />
          </div>
          <div>
            <Money
              value={-entityTotal.discounts.reseller.totalNet.centAmount}
              currency={entityTotal.discounts.reseller.totalNet.currencyCode}
            />
          </div>
        </div>
      )}

      {entityTotal.discounts.product && (
        <div className="pd-flex pd-gap-4" key="promotionProduct">
          <div className="pd-grow pd-font-bold">
            <FormattedMessage id="discountPlatformDiscount.product" defaultMessage="Product Discount" />
          </div>
          <div>
            <Money
              value={-entityTotal.discounts.product.totalNet.centAmount}
              currency={entityTotal.discounts.product.totalNet.currencyCode}
            />
          </div>
        </div>
      )}

      {entityTotal.discounts.unCategorized && (
        <div className="pd-flex pd-gap-4" key="promotionUnCategorized">
          <div className="pd-grow pd-font-bold">
            <FormattedMessage id="discountPlatformDiscount.remainingDiscount" defaultMessage="Discount" />
          </div>
          <div>
            <Money
              value={-entityTotal.discounts.unCategorized.totalNet.centAmount}
              currency={entityTotal.discounts.unCategorized.totalNet.currencyCode}
            />
          </div>
        </div>
      )}

      {entityTotal?.customerDiscount?.totalNet.centAmount && entityTotal.customerDiscount.totalNet.centAmount < 0 && (
        <div className="pd-flex pd-gap-4" key="customerDiscount">
          <div className="pd-grow pd-font-bold">
            <FormattedMessage id="checkout.customerDiscountPrice" defaultMessage="Customer Discount" />
          </div>
          <div>
            <Money
              value={entityTotal.customerDiscount.totalNet.centAmount}
              currency={entityTotal.customerDiscount.totalNet.currencyCode}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default OrderDiscountSummary;
